import { decodeJwt } from 'jose';

export const decode = async (token) => decodeJwt(token);

const token = {
  decode,
};

export default token;
